import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { getDataSourceCategoriesArr } from 'src/app/shared/enums/data-source-category';

@Component({
    standalone: false,
    selector: 'app-data-source-category-subform',
    templateUrl: './data-source-category-subform.component.html',
    styleUrls: ['./data-source-category-subform.component.scss']
})
export class DataSourceCategorySubformComponent implements OnInit {
    @Input()
    disableLayers: boolean;

    @Output()
    formReady = new EventEmitter<FormGroup>();

    layers: FormGroup;

    constructor(private formBuilder: FormBuilder) {}

    ngOnInit(): void {
        this.layers = this.formBuilder.group({
            city: new FormControl(true),
            county: new FormControl(true),
            state: new FormControl(true)
        });
        this.formReady.emit(this.layers);
    }

    static getQueryParams(formGroup: any) {
        return JSON.stringify(getDataSourceCategoriesArr(formGroup));
    }
}
